// Pages/ViewBudgetMaster.jsx
import { useEffect, useState } from "react";
import { downloadAllAssetDataExcel } from "../../Api/AssetManagement";
import { Container, Table, Button } from "react-bootstrap";
import moment from "moment";
import { FaDownload } from "react-icons/fa";
import Logo from "../../Components/Logo";
import { useServiceContext } from '../../Context/MasterContext/ServiceContext';
import { Link } from "react-router-dom";
import { FaPencilAlt, FaCheck } from "react-icons/fa";

const CustomerRequestList = () => {
    const { requestServiceData,
        loadRequestServices } = useServiceContext();
    const [loading, setLoading] = useState(false);

    console.log(requestServiceData, 'requestServiceData')

  
    useEffect(() => {
        loadRequestServices();
    }, []);

    return (
       <>
            <div className="main-content expand">
                <Container fluid className="list-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Logo />
                        </div>
                    )}
                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Request Lists</h2>
                        </div>
                        {/* <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={downloadAsssetExcelData}
                            >
                                <FaDownload className='file-icon' />
                            </button>
                        </div> */}
                    </div>

                    {requestServiceData.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    <th>Request ID</th>
                                    <th>Location</th>
                                    <th>Customer</th>
                                    {/* <th>Requested Ser.</th> */}
                                    {/* <th>Requested Item</th> */}
                                    {/* <th>Pref Date</th>
                                    <th>Pref Time</th> */}
                                    {/* <th>Proposed Date</th> */}

                                    <th>Message</th>
                                    <th>Status</th>
                                    <th>Created At</th>
                                    <th>Created By</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requestServiceData.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{budget.customerRequestId}</td>
                                        <td>{budget.customerLocationId}</td>
                                        <td>{budget.customerCode}</td>
                                      

                                        <td>{budget.remarks}</td>
                                        <td>{budget.serviceStatus}</td>
                                        <td>{moment(budget.createdDate).format('L')} at {budget.createdTime}</td>
                                        <td>{budget.createdBy}</td>
                                        <td>
                                            <Link to={`/services/request-list/customer/${budget.customerRequestId}`} className="edit-link">
                                                <FaPencilAlt className="edit-icon" />
                                            </Link>
                                            {/* <Button onClick={() => sendCustomerMail(budget.customerRequestId)} className="edit-link bg-success-g">
                                                <FaCheck className="edit-icon" />
                                            </Button> */}
                                        </td>
                                        {/* <td>

                                        </td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Data found.</p>
                    )}
                </Container>
            </div>
        </>
    );
};

export default CustomerRequestList